export default __webpack_public_path__ + "static/small-batch-8a27c64cd9dd4ee0f961e82c6240db4a.jpg";